import React, { Component } from 'react';
import { Animated } from "react-animated-css";
import { connect } from 'react-redux';
import { callApi } from '../../store/reducers/commonFunction'
import errorMessages from '../../store/reducers/errorMessages'
import common from '../../store/reducers/commons'

class ConfirmPassword extends Component {

    /**
    |--------------------------------------------------
    | constructor
    |--------------------------------------------------
    */

    constructor(props) {
        super(props)
        this.state = {

            newPassword: '',
            confirmPassword: '',
            errors: {
                newPassword: '',
                confirmPassword: ''
            },
            isFormValid: true
        }
        this.changePassword = this.changePassword.bind(this)
    }

    /**
    |--------------------------------------------------
    | handleChange
    |--------------------------------------------------
    */

    handleChange = event => {
        let { errors, isFormValid } = this.state;
        this.setState({ [event.target.name]: event.target.value })
        if (!isFormValid) {
            if (event.target.name === 'newPassword') {
                if (!common.validatePassword(event.target.value)) errors.newPassword = errorMessages.PROVIDE_VALID_PASSWORD;
                else errors.newPassword = '';
            }
            else {
                if (this.state.newPassword !== event.target.value) errors.confirmPassword = errorMessages.PASSWORD_NOT_MATCHED;
                else errors.confirmPassword = '';
            }
        }
    }

    /**
    |--------------------------------------------------
    | validateForm
    |--------------------------------------------------
    */

    validateForm() {
        let { newPassword, confirmPassword, errors, isFormValid } = this.state;

        //for newpassword
        if (!newPassword.trim()) errors.newPassword = errorMessages.PROVIDE_NEW_PASSWORD;
        else if (!common.validatePassword(newPassword)) errors.newPassword = errorMessages.PROVIDE_VALID_PASSWORD;
        else errors.newPassword = '';
        //for confirm password
        if (!confirmPassword.trim()) errors.confirmPassword = errorMessages.PROVIDE_CONFIRM_PASSWORD;
        else if (newPassword !== confirmPassword) errors.confirmPassword = errorMessages.PASSWORD_NOT_MATCHED;
        else errors.confirmPassword = '';
        if (errors.newPassword !== '' || errors.confirmPassword !== '') isFormValid = false;
        else isFormValid = true;
        this.setState({ errors, isFormValid })
        return isFormValid
    }

    /**
    |--------------------------------------------------
    | changePassword
    |--------------------------------------------------
    */

    async changePassword(e) {
        e.preventDefault()
        const { newPassword } = this.state;
        var body = {
            'password': newPassword,
            "token": "VjIxNFlXRnNTalpYVkU1b1ZqRktXVmt5TVV0VU1EQjZZak5rVUZKRlNqTldhMUpEVWpGS2RGTlVVazlTUmtvelZWY3hkMk15VW5KVGJUVlBZa1ZLVUZaR1dtRldWbFpGVVd4V2FsSnNTa3hYVmxaUFUwWmtjMkZGVW10U1dHaEpWVEJTVTFSR1VuRlRibHBzVmtWS2RsVXdWVEZpYlZKeFZXeHdWRll5WnpGVk1qVkxWREE1U1ZadWFGVmlhMXBEV2tWa2QxTXhUWHBTYmxwUVUwZG9VMVp0TlZOak1WcFpWV3Q0Vm1KdGFGQlVWV013VFVaR2NscEVVbWhXYTBwTldsWm9hazVXY0ZWVmJGWlBZVEZhTmxZeU1XdFNNVVowVkZoa2JHRnRVbHBYVnpWS1VGRTlQUT09"
        }
        if (this.validateForm()) {
            const response = await this.props.callApi('/setPassword', body, 'post', null, true);
            if (response.data.status === true) {
                common.showSuccessMessage("Password has been changed Successfully.")
                this.props.history.push('/dashboard')
            }
        }
    }

    /**
    |--------------------------------------------------
    | handleShow
    |--------------------------------------------------
    */

    handleShow = (modename) => {
        this.setState({ show: true });
    }

    /**
    |--------------------------------------------------
    | handleClose
    |--------------------------------------------------
    */

    handleClose = (modename) => {
        this.setState({ show: false });
    }

    /**
    |--------------------------------------------------
    | resetPassword
    |--------------------------------------------------
    */

    resetPassword = async (event) => {
        event.preventDefault();
        try {
            let { email } = this.state;
            let body = {
                email,
            };
            const data = await this.props.callApi('/requestResetPassword', body, 'post', 'PROVIDE_VALID_EMAIL');
            if (data.data.status === true) {
                this.props.history.push('/setPasscode')
            }
        } catch (error) {
            throw (error)
        }
    }

    /**
    |--------------------------------------------------
    | render
    |--------------------------------------------------
    */

    render() {
        let { newPassword, confirmPassword, errors } = this.state
        return (
            <div className="login-register-wrapper set-passcode-page">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-5 mx-auto d-flex flex-column justify-content-center">
                            <h2 className="page-heading">Set Passcode</h2>

                            <form>
                                <div className="form-group mb-4">
                                    <input
                                        className='form-control'
                                        type='password'
                                        name='newPassword'
                                        value={newPassword}
                                        placeholder='Enter New Password'
                                        id='newpassword'
                                        required
                                        onChange={this.handleChange}
                                    />
                                    <span className='error-block'> {errors.newPassword}</span>
                                </div>
                                <div className="form-group mb-4 ">
                                    <input
                                        className='form-control'
                                        type='password'
                                        name='confirmPassword'
                                        value={confirmPassword}
                                        placeholder='Enter Confirm Password'
                                        id='confirmpassword'
                                        required
                                        onChange={this.handleChange}
                                    />

                                    <span className='error-block'>{errors.confirmPassword}
                                    </span>
                                </div>
                                {/* <Link type="submit" className="btn btn-primary btn-block" to="/feedback">continue</Link> */}
                                <button
                                    type='submit'
                                    className='btn btn-primary btn-block'
                                    onClick={this.changePassword}
                                >
                                    <span>continue</span>
                                </button>
                            </form>
                        </div>

                        <div className="col-xl-7 col-lg-6 text-center d-lg-block d-none">
                            <div className="set-passcode-img-block">
                                <img src="images/set-passcode-bgi-img.svg" alt="" />
                                <div className="set-passcode-touche-1">
                                    <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} animationInDelay={1100}>
                                        <img src="images/set-passcode-touch-1-img.svg" alt="" />
                                    </Animated>
                                </div>
                                <div className="set-passcode-touche-2">
                                    <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} animationInDelay={1150}>
                                        <img src="images/set-passcode-touch-2-img.svg" alt="" />
                                    </Animated>
                                </div>
                                <div className="set-passcode-touche-3">
                                    <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} animationInDelay={1300}>
                                        <img src="images/set-passcode-touch-3-img.svg" alt="" />
                                    </Animated>
                                </div>
                                <div className="set-passcode-hand-touch-block">
                                    <Animated animationIn="zoomIn   " animationOut="fadeOut" isVisible={true} animationInDelay={100}>
                                        <img src="images/set-passcode-hand-touch-img.svg" alt="" />
                                    </Animated>
                                </div>
                                <div className="set-passcode-bgi-bottom-img-block">
                                    <img src="images/set-passcode-bgi-bottom-img.svg" alt="" />
                                </div>
                                <div className="set-passcode-wifi-signals-1">
                                    <Animated animationIn="flash" animationOut="fadeOut" isVisible={true} animationInDelay={2300}>
                                        <img src="images/set-passcode-wifi-signal-1-img.svg" alt="" />
                                    </Animated>
                                </div>
                                <div className="set-passcode-wifi-signals-2">
                                    <Animated animationIn="flash" animationOut="fadeOut" isVisible={true} animationInDelay={2400}>
                                        <img src="images/set-passcode-wifi-signal-2-img.svg" alt="" />
                                    </Animated>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default connect(null, { callApi })(ConfirmPassword)